



































// vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

// 组件
import {Toast} from 'vant';

// http
import http from '@/utils/http';

@Component({
  components: {
  },
})
export default class App extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: {},
  })
  public data!: any;

  @Prop({
    type: Object,
    required: true,
    default: {},
  })
  public dataList!: any;

  public toPage(item: any) {
    this.$router.push({
      path: '/news-article',
      query: {
        data: JSON.stringify(item),
      },
    });
  }
}
